export default "__VITE_ASSET__a57d3b7b__"